import { CommonModule }         from '@angular/common';
import { NgModule }             from '@angular/core';
import {
	FormsModule,
	ReactiveFormsModule
}                               from '@angular/forms';
import { FormInputModule }      from '@app/shared/form-elements/form-input/form-input.module';
import { FormSelectModule }     from '@app/shared/form-elements/form-select/form-select.module';
import { AddressFormComponent } from '@app/shared/forms/address-form/address-form.component';
import { CountryModule }        from '@shared/components/country/country.module';

@NgModule( {
	declarations: [
		AddressFormComponent
	],
	imports: [
		// Angular
		CommonModule,
		FormsModule,
		ReactiveFormsModule,

		// Shared
		FormInputModule,
		FormSelectModule,
		CountryModule
	],
	exports: [
		AddressFormComponent
	],
	providers: []
} )
export class AddressFormModule {}
